import axios from 'axios';
import { ref } from 'vue';
import { useConfirm } from 'primevue/useconfirm';

export function handleActionBase(
    selectedAction,
    rowData,
    confirmInstance,
    confirmGroup = null
) {
    const action = selectedAction.value;

    if (action.confirm) {
        confirmInstance.require({
            group: confirmGroup ?? '',
            message: action.confirmationMessage || 'Are you sure?',
            header: action.label,
            icon: action.icon,
            color: action.color,
            accept: () => performAction(action, rowData),
        });
    } else {
        performAction(action, rowData);
    }
}

export function performAction(action, rowData) {
    if (action.method.toUpperCase() === 'GET') {
        window.location.href = action.url;
    } else if (action.method.toUpperCase() === 'POST') {
        ajaxindicatorstart('loading...');
        axios({
            method: action.method,
            url: action.url,
            data: action.data,
        })
            .then((response) => {
                window.location.reload();
                ajaxindicatorstop();
            })
            .catch((error) => {
                window.location.reload();
                ajaxindicatorstop();
            });
    } else {
        ajaxindicatorstart('loading...');
        axios({
            method: action.method,
            url: action.url,
            data: rowData,
        })
            .then((response) => {
                window.location.reload();
                ajaxindicatorstop();
            })
            .catch((error) => {
                window.location.reload();
                ajaxindicatorstop();
            });
    }
}


export default function useDatatableActions(resource, type) {
    const confirm = useConfirm();
    const rowContextMenuRef = ref(null);
    const tableContextMenuRef = ref(null);

    const rowMenuModel = ref([
        {
            label: 'Export',
            icon: 'far fa-file-export',
            command: () => exportCSV(),
        },
        { separator: true },
        {
            label: 'Clear Filter',
            icon: 'far fa-filter',
            command: () => clearFilter(),
        },
        {
            label: 'Refresh',
            icon: 'far fa-sync-alt',
            command: () => fetchData(),
        },
        {
            label: 'Settings',
            icon: 'far fa-cog',
            items: [
                {
                    label: 'Toggle Advanced Filter',
                    icon: 'far fa-filter',
                    command: () => (advancedFilter.value = !advancedFilter.value),
                },
                {
                    label: 'Selection Mode',
                    icon: 'far fa-check-square',
                    items: [
                        {
                            label: 'Single',
                            icon: 'far fa-check',
                            command: () => (selectionMode.value = 'single'),
                        },
                        {
                            label: 'Multiple',
                            icon: 'far fa-check',
                            command: () => (selectionMode.value = 'multiple'),
                        },
                    ],
                },
            ],
        },
    ]);

    const tableMenuModel = ref(rowMenuModel.value);

    function hideAllContextMenus() {
        rowContextMenuRef.value?.hide();
        tableContextMenuRef.value?.hide();
    }

    function onRowContextMenu(event) {
        hideAllContextMenus();
        rowContextMenuRef.value?.show(event.originalEvent);
    }

    function onTableContextMenu(event) {
        tableContextMenuRef.value?.show(event);
    }

    function handleAction(selectedAction, rowData) {
        const confirmGroup = `${resource}_${type}`;
        handleActionBase(selectedAction, rowData, confirm, confirmGroup);
    }

    function view(item) {
        console.log('View', item);
    }
    function edit(item) {
        console.log('Edit', item);
    }

    return {
        rowContextMenuRef,
        tableContextMenuRef,
        rowMenuModel,
        tableMenuModel,
        onRowContextMenu,
        onTableContextMenu,
        hideAllContextMenus,
        handleAction,
        performAction,
        view,
        edit,
    };
}
